import CoreIslandWidgetFactory from "./islands/core";

const WidgetsFactory = (widgetName: string, widgetProps: any) => {
    return CoreIslandWidgetFactory(widgetName, widgetProps);
};

export { WidgetsFactory };
export default WidgetsFactory;
